import React from 'react'
import ProjectDesc from '../../Components/DashboardCom/ProjectDesc'
import DashHeader from '../../Components/DashboardCom/Header/DashHeader'
import Footer from '../../Components/Footer/Footer'
const DashProjectDes = () => {
  return (
    <div>
        <DashHeader />
        <ProjectDesc />
        {/* <Footer /> */}
    </div>
  )
}

export default DashProjectDes